/* ECT Upsell v3.1 (EcoTech) - JS dung chung cho trang SP va gio. Nap 1 lan toan trang. */
(function () {
  if (window.__ectUp31) return;
  window.__ectUp31 = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function yen(c) { return '¥' + Math.round(Number(c) / 100).toLocaleString('ja-JP'); }
  function yenNum(c) { return Math.round(Number(c) / 100).toLocaleString('ja-JP'); }

  function qtyInput(box) {
    var fid = box && box.dataset.ectForm;
    if (!fid) return null;
    return document.getElementById(fid + '-quantity') || document.querySelector('input[name="quantity"][form="' + fid + '"]');
  }
  function variantInput(box) {
    var f = box && document.getElementById(box.dataset.ectForm);
    return f && f.elements ? f.elements.namedItem('id') : null;
  }
  function curQty(box) {
    var q = qtyInput(box);
    return Math.max(1, Math.floor(Number(q && q.value) || 1));
  }

  function markTiers(box) {
    box.querySelectorAll('.ect-up__tier').forEach(function (l) {
      var r = l.querySelector('input');
      l.classList.toggle('is-sel', !!(r && r.checked));
    });
  }

  function saveLine(box, r) {
    var line = box.querySelector('.ect-up__saveline');
    if (!line) return;
    var sv = Number(r && r.dataset.ectSave) || 0;
    line.textContent = sv > 0 ? (r.dataset.ectQty + '台で' + yenNum(sv) + '円お得（購入手続き画面で適用）') : '';
  }

  function fbtTotal(box) {
    var sec = box && box.querySelector('[data-ect-fbt]');
    if (!sec) return;
    var qa = curQty(box);
    var t = (Number(sec.dataset.ectAPrice) || 0) * qa, sv = 0, n = qa;
    sec.querySelectorAll('[data-ect-b]').forEach(function (c) {
      if (c.checked) { t += Number(c.dataset.ectBPrice) || 0; sv += Number(c.dataset.ectBSave) || 0; n += 1; }
    });
    var aq = sec.querySelector('[data-ect-aqty]');
    if (aq) aq.textContent = qa;
    var tt = sec.querySelector('[data-ect-total]'), ts = sec.querySelector('[data-ect-totalsave]'), btn = sec.querySelector('[data-ect-fbt-add]');
    if (tt) tt.textContent = yen(t);
    if (ts) ts.textContent = sv > 0 ? ('セット割 ' + yenNum(sv) + '円お得') : '';
    if (btn) { btn.textContent = n + '点まとめてカートに追加'; btn.disabled = n <= qa; }
  }

  function syncFromQty(box) {
    var v = curQty(box), best = null, bestQ = 0;
    box.querySelectorAll('input[data-ect-qty]').forEach(function (x) {
      var q = Number(x.dataset.ectQty);
      if (!x.disabled && q <= v && q >= bestQ) { best = x; bestQ = q; }
    });
    if (best) best.checked = true;
    markTiers(box);
    saveLine(box, best && Number(best.dataset.ectQty) === v ? best : null);
    fbtTotal(box);
  }

  function init() {
    document.querySelectorAll('.ect-up').forEach(function (box) { syncFromQty(box); });
  }

  function openCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); } catch (e) {} }
  }

  async function post(path, body) {
    var r = await fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
    var j = null;
    try { j = await r.json(); } catch (e) {}
    if (!r.ok) throw new Error((j && j.description) || path);
    return j;
  }

  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('input[data-ect-qty]');
    if (r) {
      var box = r.closest('.ect-up'), q = qtyInput(box);
      if (q) {
        q.value = r.dataset.ectQty;
        q.dispatchEvent(new Event('input', { bubbles: true }));
        q.dispatchEvent(new Event('change', { bubbles: true }));
      }
      markTiers(box); saveLine(box, r); fbtTotal(box);
      return;
    }
    var c = e.target.closest && e.target.closest('[data-ect-b]');
    if (c) { fbtTotal(c.closest('.ect-up')); return; }
    if (e.target.name === 'quantity') {
      document.querySelectorAll('.ect-up').forEach(function (box) { if (qtyInput(box) === e.target) syncFromQty(box); });
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.name !== 'quantity') return;
    document.querySelectorAll('.ect-up').forEach(function (box) { if (qtyInput(box) === e.target) { markTiers(box); fbtTotal(box); } });
  });

  document.addEventListener('click', async function (e) {
    var fb = e.target.closest && e.target.closest('[data-ect-fbt-add]');
    var g = e.target.closest && e.target.closest('[data-ect-grow]');
    var a = e.target.closest && e.target.closest('[data-ect-addone]');
    var b = fb || g || a;
    if (!b || b.disabled) return;
    b.disabled = true;

    if (fb) {
      var box = fb.closest('.ect-up'), sec = fb.closest('[data-ect-fbt]'), msg = sec.querySelector('.ect-up__msg');
      var idEl = variantInput(box), qa = curQty(box);
      var items = [{ id: Number((idEl && idEl.value) || sec.dataset.ectA), quantity: qa }];
      sec.querySelectorAll('[data-ect-b]').forEach(function (c) { if (c.checked) items.push({ id: Number(c.dataset.ectB), quantity: 1 }); });
      var want = items.reduce(function (s, it) { return s + it.quantity; }, 0);
      var label = fb.textContent; fb.textContent = '追加中…'; if (msg) msg.textContent = '';
      try {
        var res = await post('cart/add.js', { items: items });
        var got = (res && res.items ? res.items : []).reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
        if (msg) msg.textContent = got >= want ? (want + '点をカートに追加しました。') : '一部の商品は在庫の都合で数量が調整されました。カートをご確認ください。';
        openCart();
      } catch (err) {
        if (msg) msg.textContent = '一部の商品を追加できなかった可能性があります（在庫切れなど）。カートの内容をご確認ください。';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      fb.textContent = label; fb.disabled = false; fbtTotal(box);
      return;
    }

    var wrap = b.closest('.ect-upc'), err = wrap && wrap.querySelector('.ect-upc__err');
    if (err) err.textContent = '';
    try {
      if (g) {
        var cart = await (await fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })).json();
        var line = cart.items.filter(function (it) { return it.key === g.dataset.ectGrow; })[0];
        if (!line) throw new Error('line');
        await post('cart/change.js', { id: line.key, quantity: line.quantity + Math.max(1, Number(g.dataset.ectNeed) || 1) });
      } else {
        await post('cart/add.js', { items: [{ id: Number(a.dataset.ectAddone), quantity: 1 }] });
      }
    } catch (x) {
      if (err) err.textContent = '追加できませんでした（在庫が足りない可能性があります）。';
      b.disabled = false;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  });

  function vmap(box) {
    var m = {};
    (box.dataset.ectVp || '').split(',').forEach(function (s) {
      var a = s.split(':'); if (a.length >= 4) m[a[0]] = { p: Number(a[1]), inv: Number(a[2]), lim: a[3] === '1' };
    });
    return m;
  }
  function recompute(box) {
    var vi = variantInput(box), vid = vi && vi.value;
    if (!vid || box._ectVid === vid) return;
    var v = vmap(box)[vid];
    box._ectVid = vid;
    if (!v) return;
    var p = v.p, pct = box.dataset.ectPct === '1';
    var p1 = box.querySelector('.ect-up__p1'); if (p1) p1.textContent = yen(p);
    box.querySelectorAll('input[data-ect-o]').forEach(function (r) {
      var q = Number(r.dataset.ectQty), o = Number(r.dataset.ectO);
      var per = pct ? Math.floor(p * o / 100) : Math.min(o * 100, p);
      var unit = p - per, tot = unit * q, cmp = p * q;
      r.dataset.ectSave = cmp - tot;
      var l = r.closest('.ect-up__tier'), off = v.lim && v.inv < q;
      r.disabled = off; if (off && r.checked) { var one = box.querySelector('input[data-ect-qty="1"]'); if (one) one.checked = true; }
      if (l) {
        l.classList.toggle('is-off', off);
        var u = l.querySelector('.ect-up__unit'); if (u) u.textContent = off ? '在庫不足のため選択できません' : (q + '台の場合 1台 ' + yen(unit));
        var t = l.querySelector('.ect-up__tot'); if (t) t.textContent = yen(tot);
        var c = l.querySelector('.ect-up__cmp'); if (c) c.textContent = '割引前合計 ' + yen(cmp);
      }
    });
    var sec = box.querySelector('[data-ect-fbt]'); if (sec) { sec.dataset.ectAPrice = p; sec.dataset.ectA = vid; }
    syncFromQty(box);
  }
  function recomputeAll() { document.querySelectorAll('.ect-up').forEach(recompute); }
  document.addEventListener('variant:change', function () { setTimeout(recomputeAll, 0); });
  document.addEventListener('change', function () { setTimeout(recomputeAll, 60); });
  document.addEventListener('click', function () { setTimeout(recomputeAll, 120); });
  var seen = new WeakSet();
  new MutationObserver(function () {
    document.querySelectorAll('.ect-up').forEach(function (box) { if (!seen.has(box)) { seen.add(box); syncFromQty(box); } });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
